export enum SpecialDDLOptionsEnum {
  ALL = 'All',
  UNSPECIFIED = 'Unspecified'
}